import { render, staticRenderFns } from "./ProfileUpdate.vue?vue&type=template&id=b8a31fa8&scoped=true"
import script from "./ProfileUpdate.vue?vue&type=script&lang=js"
export * from "./ProfileUpdate.vue?vue&type=script&lang=js"
import style0 from "./ProfileUpdate.vue?vue&type=style&index=0&id=b8a31fa8&prod&lang=scss&scoped=true"
import style1 from "./ProfileUpdate.vue?vue&type=style&index=1&id=b8a31fa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a31fa8",
  null
  
)

export default component.exports